"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("../styles");
const useStyles = (0, styles_1.createUseThemeStyles)((theme) => ({
    input: {
        "fontFamily": theme.typography.primary,
        "fontSize": "1.1rem",
        "color": theme.palette.light.neutral,
        "background": theme.palette.secondary.dark,
        "border": `2px solid ${theme.palette.secondary.light}`,
        "borderRadius": "4px",
        "padding": "0.4rem 0.6rem",
        "outline": "none",
        "&::placeholder": {
            color: "hsl(0deg 0% 100% / 0.4)",
        },
        "&:focus": {
            borderColor: theme.palette.accent.neutral,
        },
    },
}));
exports.Input = React.forwardRef((_a, ref) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = useStyles();
    return (React.createElement("input", Object.assign({ ref: ref, className: (0, classnames_1.default)(classes.input, className) }, rest)));
});
exports.Input.displayName = "Input";
